// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"a7fa9f50","607":"071c82a4"}[chunkId] + ".chunk.js";
};